import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import { useTheme } from "@mui/material/styles";
import { useGetAllPurDhashCatgoryVariantQuery } from "../../../Api/attoDeskApi";
import { CircularProgress } from "@mui/material";

interface CategoryVariantCount {
  categoryName: string;
  count: number;
}

HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);

const PayrollDashboard = () => {
  const theme = useTheme();

  const { data, isLoading } = useGetAllPurDhashCatgoryVariantQuery({ id: "" });

  const chartData: CategoryVariantCount[] = Array.isArray(data?.data)
    ? data?.data ?? []
    : [];

  const pieData = useMemo<Highcharts.PointOptionsObject[]>(
    () =>
      chartData.map((item) => ({
        name: item.categoryName,
        y: Number(item.count),
      })),
    [chartData]
  );

  const pieChartOptions: Highcharts.Options = useMemo(
    () => ({
      chart: {
        type: "pie",
        backgroundColor: theme.palette.cardAdd?.bgColor || "#fff",
      },

      title: {
        text: "",
        style: {
          color: theme.palette.heading?.headingColor || "#000",
          fontSize: "14px",
        },
      },

      tooltip: {
        pointFormat: "<b>{point.y}</b> Variants<br/>({point.percentage:.1f}%)",
      },

      colors: [
        Highcharts.color(theme.palette.primary.main).brighten(0.2).get(),
        Highcharts.color(theme.palette.primary.main).get(),
        Highcharts.color(theme.palette.primary.main).brighten(-0.1).get(),
        Highcharts.color(theme.palette.primary.dark).get(),
        Highcharts.color(theme.palette.primary.light).get(),
      ],

      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },

      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "{point.name}: {point.percentage:.1f}%",
          },
          showInLegend: true,
        },
      },

      series: [
        {
          type: "pie",
          name: "Variants",
          data: pieData,
        },
      ],

      credits: { enabled: false },
    }),
    [pieData, theme]
  );

  return (
    <div style={{ padding: "5px" }}>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={pieChartOptions} />
      )}
    </div>
  );
};

export default PayrollDashboard;
